export default "__VITE_ASSET__BKovXygF__"